import { render } from "./ConfigurationDeleteDialog.vue?vue&type=template&id=5d59176c"
import script from "./ConfigurationDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfigurationDeleteDialog.vue?vue&type=script&lang=js"

import "./ConfigurationDeleteDialog.vue?vue&type=style&index=0&id=5d59176c&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog});qInstall(script, 'directives', {ClosePopup});
